import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconTranslate.tsx
const OutlinedFilledTranslate = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m447-55 187-514h131L951-55H848l-33-85H581l-33 85H447ZM150-169l-67-67 197-196q-58-61-94.5-116.5T134-651h108q10 31 37 69t69 82q44-48 80-112t50-119H10v-95h290v-80h95v80h290v95H582q-18 74-64 155T413-432l66 67-37 102-97-101-195 195Zm463-61h170l-85-228-85 228Z" })
});
const OutlinedTranslate = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m447-55 187-514h131L951-55H848l-33-85H581l-33 85H447ZM150-169l-67-67 197-196q-58-61-94.5-116.5T134-651h108q10 31 37 69t69 82q44-48 80-112t50-119H10v-95h290v-80h95v80h290v95H582q-18 74-64 155T413-432l66 67-37 102-97-101-195 195Zm463-61h170l-85-228-85 228Z" })
});
const RoundedFilledTranslate = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m581-140-22 54q-5 14-17 22.5T515-55q-25 0-39-19.5t-6-43.5l150-410q6-18 21.5-29.5T677-569h45q19 0 35 11.5t22 29.5l149 408q9 25-5.5 45T882-55q-15 0-28-9t-18-23l-21-53H581ZM345-364 183-202q-15 14-33.5 14T117-203q-15-14-15-33t15-33l163-163q-58-61-94.5-116.5T134-651h108q10 31 37 69t69 82q44-48 80-112t50-119H57q-20 0-33.5-13.5T10-778q0-20 13.5-34T57-826h243v-32q0-20 13.5-34t33.5-14q20 0 34 14t14 34v32h242q20 0 34 14t14 34q0 20-14 33.5T637-731h-55q-18 74-64 155T413-432l66 67-37 102-97-101Zm268 134h170l-85-228-85 228Z" })
});
const RoundedTranslate = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m581-140-22 54q-5 14-17 22.5T515-55q-25 0-39-19.5t-6-43.5l150-410q6-18 21.5-29.5T677-569h45q19 0 35 11.5t22 29.5l149 408q9 25-5.5 45T882-55q-15 0-28-9t-18-23l-21-53H581ZM345-364 183-202q-15 14-33.5 14T117-203q-15-14-15-33t15-33l163-163q-58-61-94.5-116.5T134-651h108q10 31 37 69t69 82q44-48 80-112t50-119H57q-20 0-33.5-13.5T10-778q0-20 13.5-34T57-826h243v-32q0-20 13.5-34t33.5-14q20 0 34 14t14 34v32h242q20 0 34 14t14 34q0 20-14 33.5T637-731h-55q-18 74-64 155T413-432l66 67-37 102-97-101Zm268 134h170l-85-228-85 228Z" })
});
const SharpFilledTranslate = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m447-55 187-514h131L951-55H848l-33-85H581l-33 85H447ZM150-169l-67-67 197-196q-58-61-94.5-116.5T134-651h108q10 31 37 69t69 82q44-48 80-112t50-119H10v-95h290v-80h95v80h290v95H582q-18 74-64 155T413-432l66 67-37 102-97-101-195 195Zm463-61h170l-85-228-85 228Z" })
});
const SharpTranslate = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m447-55 187-514h131L951-55H848l-33-85H581l-33 85H447ZM150-169l-67-67 197-196q-58-61-94.5-116.5T134-651h108q10 31 37 69t69 82q44-48 80-112t50-119H10v-95h290v-80h95v80h290v95H582q-18 74-64 155T413-432l66 67-37 102-97-101-195 195Zm463-61h170l-85-228-85 228Z" })
});
const componentMap = {
	outlined: OutlinedTranslate,
	"outlined-fill": OutlinedFilledTranslate,
	rounded: RoundedTranslate,
	"rounded-fill": RoundedFilledTranslate,
	sharp: SharpTranslate,
	"sharp-fill": SharpFilledTranslate
};
const IconTranslate = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconTranslate };